export default "__VITE_ASSET__7b89b62f__"